import { useIsVerticalizedSignUp } from "@faire/retailer-visitor-shared/views/SignUp/_verticalized-signup/useIsVerticalizedSignUp";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled, { css } from "styled-components";

const StyledFormContainer = styled(Column)<{ $isVerticalizedSignUp: boolean }>`
  margin: auto;
  width: 100%;
  ${({ $isVerticalizedSignUp }) =>
    $isVerticalizedSignUp
      ? ""
      : css`
          padding: ${getSpacing("4x", "3x")};
          ${responsiveMediaQueries.tabletAndAbove} {
            padding: ${getSpacing("8x", 120)};
            max-width: 720px;
          }
        `}
`;

export const SignupFormContainer: React.FC<
  React.ComponentProps<typeof Column>
> = (props) => {
  const isVerticalizedSignUp = useIsVerticalizedSignUp();
  return (
    <StyledFormContainer
      $isVerticalizedSignUp={isVerticalizedSignUp}
      {...props}
    />
  );
};
